import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { faUser, faCircleArrowRight, faHandshake, faCommentDollar, faStore } from '@fortawesome/free-solid-svg-icons'
import { faStripe, faCcStripe } from '@fortawesome/free-brands-svg-icons'
import { useTranslation } from 'react-i18next'

const BRAND      = '#6eb446'
const BRAND_DARK = '#2d5918'

const Payments: React.FC = () => {
  const { t } = useTranslation()

  const allPayments = [
    { title: t('payments.pay_customer'),  subtitle: t('payments.go_customer'),  link: 'admin/customers',  faicon: faUser,         disabled: false },
    { title: t('payments.pay_partners'),  subtitle: t('payments.go_partners'),  link: 'admin/partners',   faicon: faHandshake,    disabled: false },
    { title: t('payments.pay_marketing'), subtitle: t('payments.go_marketing'), link: 'admin/marketings', faicon: faCommentDollar, disabled: false },
    { title: t('payments.pay_stores'),    subtitle: t('payments.go_stores'),    link: 'admin/stores',     faicon: faStore,         disabled: false },
    { title: t('payments.create'),        subtitle: t('payments.create'),        link: '#',                faicon: faStripe,        disabled: true  },
    { title: t('payments.show'),          subtitle: t('payments.show'),          link: '#',                faicon: faCcStripe,      disabled: true  },
  ]

  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 g-4 p-4">
      {allPayments.map((e, i) => (
        <div key={i} className={`col animate__animated animate__fadeIn${e.disabled ? ' opacity-25' : ''}`}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius   : 16,
            boxShadow      : '0 4px 20px rgba(0,0,0,0.07)',
            border         : '1px solid #f1f5f9',
            overflow       : 'hidden',
            height         : '100%',
            display        : 'flex',
            flexDirection  : 'column',
          }}>
            <div style={{ height: 4, background: `linear-gradient(90deg, ${BRAND_DARK}, ${BRAND})` }} />
            <div style={{ padding: '1.5rem', flex: 1 }}>
              <Link to={e.link} className="text-decoration-none">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>
                  <div>
                    <p style={{ margin: 0, fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                      {e.subtitle}
                    </p>
                    <p style={{ margin: 0, fontSize: '1rem', fontWeight: 800, color: '#1e293b' }}>
                      {e.title}
                    </p>
                  </div>
                  <div style={{
                    width: 48, height: 48, borderRadius: 12, backgroundColor: `${BRAND}18`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <FontAwesomeIcon icon={e.faicon} style={{ color: BRAND, fontSize: '1.4rem' }} />
                  </div>
                </div>
              </Link>
            </div>
            <div style={{ padding: '0.75rem 1.5rem', background: BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}>
              <Link to={e.link} className="text-decoration-none text-white d-flex align-items-center gap-1" style={{ fontWeight: 700, fontSize: '0.82rem' }}>
                <span>{e.subtitle}</span>
                <FontAwesomeIcon icon={faCircleArrowRight} />
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Payments
